import { render, staticRenderFns } from "./DialogChangeEmailHistory.vue?vue&type=template&id=5c7b1021&scoped=true&"
import script from "./DialogChangeEmailHistory.vue?vue&type=script&lang=js&"
export * from "./DialogChangeEmailHistory.vue?vue&type=script&lang=js&"
import style0 from "./DialogChangeEmailHistory.vue?vue&type=style&index=0&id=5c7b1021&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7b1021",
  null
  
)

export default component.exports